// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"6374ff48","572":"6b7aca90","618":"78634e85","925":"41a42447","989":"a355a883"}[chunkId] + ".chunk.css";
};